import { useState } from 'react';
import { Row } from 'antd';
import locale from 'antd/es/date-picker/locale/pl_PL';
import { useTranslation } from 'react-i18next';
import { Popover, container } from 'components/common';
import { Dayjs } from 'dayjs';
import styled from 'styled-components';
import { RangePicker } from 'components/rangePicker';
import { PrimaryButton, SecondaryButton } from 'components/common/button';
import { Item } from 'components/common/form';
import { CloseOutlined } from '@ant-design/icons';

const { PopoverRowContainer } = container;

type Props = {
    handleFilter: (date: [Dayjs, Dayjs] | null) => void;
    handleClear: () => void;
};

const Container = styled(PopoverRowContainer)`
    .ant-col {
        height: 50px;
    }
`;

const StyledCloseIcon = styled(CloseOutlined)`
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    font-size: 24px !important;

    svg {
        fill: ${props => props.theme.background.pink};
    }
`;

const StyledRangerPicker = styled(RangePicker)`
    width: 100%;
    padding: 8px 12px;
`;

const ReferralTableFilters = ({ handleFilter, handleClear }: Props) => {
    const [date, setDate] = useState<[any, any] | null>(null);
    const [visible, setVisible] = useState(false);

    const [t, i18n] = useTranslation('common');

    const clearFilters = () => {
        setDate(null);
    };

    const onCancel = () => {
        clearFilters();
        setVisible(false);
    };

    const onClear = () => {
        clearFilters();
        setVisible(false);
        handleClear();
    };

    const onFilter = () => {
        setVisible(false);
        handleFilter(date);
    };

    const content = (
        <Container className="popover-content">
            <StyledCloseIcon onClick={onCancel} />
            <Row justify="space-between" style={{ width: '100%' }}>
                <Item style={{ width: '100%' }} label={t('date')}>
                    {i18n.language === 'pl' ? (
                        <StyledRangerPicker
                            value={date || undefined}
                            locale={locale}
                            onChange={dates => setDate(dates)}
                        />
                    ) : (
                        <StyledRangerPicker value={date || undefined} onChange={dates => setDate(dates)} />
                    )}
                </Item>
                <Row justify="end" style={{ width: '100%' }}>
                    <SecondaryButton style={{ marginRight: '8px' }} onClick={clearFilters}>
                        {t('clear_filters')}
                    </SecondaryButton>
                    <PrimaryButton onClick={onFilter}>{t('filter')}</PrimaryButton>
                </Row>
            </Row>
        </Container>
    );

    return (
        <Row style={{ marginBottom: '8px' }}>
            <Popover
                content={content}
                className="filter-menu"
                trigger="click"
                visible={visible}
                onVisibleChange={setVisible}
                placement="bottom">
                <SecondaryButton>{t('filter')}</SecondaryButton>
            </Popover>
            <SecondaryButton style={{ marginLeft: '8px' }} onClick={onClear}>
                {t('clear')}
            </SecondaryButton>
        </Row>
    );
};

export default ReferralTableFilters;
